export default "__VITE_ASSET__f2b9de26__"